import React, { useState } from 'react';
import './users.css';
import { Button, Modal, Box, Typography } from '@mui/material';
import UserCard from '../../../components/adminComponents/userCard';
import NewUserModal from '../../../components/adminComponents/newUserModal';

const Users = ({ allUsers, userUpdate, userDelete, userRegister }) => {

  const [isNewUserModalOpen, setIsNewUserModalOpen] = useState(false);

  // Filtros individuales
  const [filterName, setFilterName] = useState('');
  const [filterEmail, setFilterEmail] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  function parseDMYtoDate(str) {
    if (!str) return null;
    const [d, m, y] = str.split('/');
    return new Date(y, m - 1, d, 23, 59, 59, 999);
  }

  const filteredUsers = allUsers.filter(user => {
    // Calcula el estatus en base a la expiración
    let status;
    if (user.status === 'activo') {
      const expDate = parseDMYtoDate(user.expirationDate);
      status = expDate && expDate < new Date() ? 'inactivo' : user.status;
    } else {
      status = user.status;
    }

    // Aplicar filtros
    const nameMatch = user.name.toLowerCase().includes(filterName.toLowerCase());
    const emailMatch = user.email.toLowerCase().includes(filterEmail.toLowerCase());
    const statusMatch = filterStatus === 'all' || status === filterStatus;

    return nameMatch && emailMatch && statusMatch;
  });


  return (
    <section className='users-container'>
      <div className='filters_container'>
        <span>Filtrar por:</span>
        <input
          type="text"
          placeholder="Nombre..."
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
          className="filter_input"
        />
        <input
          type="text"
          placeholder="Correo..."
          value={filterEmail}
          onChange={(e) => setFilterEmail(e.target.value)}
          className="filter_input"
        />
        <span>Estatus:</span>
        <select
          id='status_filter_select'
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
          className="filter_select"
        >
          <option value="all">Todos</option>
          <option value="activo">Activo</option>
          <option value="inactivo">Inactivo</option>
          <option value="suspendido">Suspendido</option>
        </select>
        <Button variant='contained' sx={{ fontSize: '0.7rem', textTransform: 'capitalize', marginLeft: 'auto' }} onClick={() => setIsNewUserModalOpen(true)}>
          Nuevo +
        </Button>
      </div>

      <div className='users-grid'>
        {filteredUsers.length === 0 ? (
          <p style={{ textAlign: 'center', width: '100%', gridArea: '1 / 1 / -1 / -1', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>No se encontraron usuarios a mostrar</p>
        ) : (
          filteredUsers.map((user, index) => (
            <UserCard
              key={index}
              user={user}
              index={index}
              userUpdate={userUpdate}
              userDelete={userDelete}
            />
          ))
        )}
      </div>
      {isNewUserModalOpen &&
        <NewUserModal isOpen={isNewUserModalOpen} onClose={setIsNewUserModalOpen} userRegister={userRegister} />
      }
    </section>
  );
};

export default Users;
